import { Box , CircularProgress, Container} from "@mui/material";

const LoadingPage = () => {
    
    return (
        
        <Container        
        >
            <Box sx = {{
                height:"100%",
                display: 'flex' , 
                justifyContent:"center",
                alignItems:"center"
            }}>
                <CircularProgress color="secondary" />
            </Box>
            
        </Container>
    );
}
export default LoadingPage;